import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import { openInNewTab } from '../../utils';

const propTypes = exact({
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  style: PropTypes.object,
});

const defaultProps = {
  style: {
    display: 'block',
    textDecoration: 'underline',
  },
};

const NewTabLink = (props) => {
  const { to, children, style: userStyle } = props;
  const style = {
    ...defaultProps.style,
    ...userStyle,
  };

  return (
    <span onClick={() => { openInNewTab(to); }} style={style} className="app-cursor-pointer">{children}</span>
  );
};

NewTabLink.propTypes = propTypes;
NewTabLink.defaultProps = defaultProps;

export default NewTabLink;
